import SiteHeader from "./components/SiteHeader";
import TickerBar from "./components/TickerBar";
import Hero from "./components/Hero";
import FeaturedDeepDive from "./components/FeaturedDeepDive";
import SectionRail from "./components/SectionRail";
import TimelineSection from "./components/TimelineSection";
import CompareSection from "./components/CompareSection";
import RankingSection from "./components/RankingSection";
import StatsStrip from "./components/StatsStrip";
import DownloadCta from "./components/DownloadCta";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <TickerBar />
      <main className="w-full">
        <Hero />
        <FeaturedDeepDive />
        <SectionRail />
        <TimelineSection />
        <CompareSection />
        <RankingSection />
        <StatsStrip />
        <DownloadCta />
      </main>
      <SiteFooter />
    </div>
  );
}